const downloadBlobImage = (blob: Blob, filename: string) => {
  const link = document.createElement('a')

  link.href = URL.createObjectURL(blob)
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export { downloadBlobImage }
